import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Zap, Clock, ChevronRight } from 'lucide-react';
import { useQuery } from 'react-query';
import { 
  getTrendingDeals, 
  getNewestDeals, 
  getGettingWarmDeals 
} from '../services/dealService';
import DealCard from './deals/DealCard';

interface DealsSection {
  title: string;
  icon: React.ReactNode;
  queryKey: string;
  fetchFunction: () => Promise<any>;
  seeAllLink: string;
  background: string;
}

const sectionData: DealsSection[] = [
  {
    title: "Getting Warm",
    icon: <Flame className="w-5 h-5 text-white" />,
    queryKey: 'gettingWarmDeals',
    fetchFunction: () => getGettingWarmDeals(4),
    seeAllLink: "/dealsBrowse?status=active&sort=getting-warm",
    background: "bg-gradient-to-r from-deal-orange to-deal-orange-dark"
  },
//   {
//     title: "Trending Deals",
//     icon: <Zap className="w-5 h-5 text-white" />,
//     queryKey: 'trendingDeals',
//     fetchFunction: () => getTrendingDeals(4),
//     seeAllLink: "/dealsBrowse?sort=trending",
//     background: "bg-gradient-to-r from-deal-blue to-blue-600"
//   },
  {
    title: "New Arrivals",
    icon: <Clock className="w-5 h-5 text-white" />,
    queryKey: 'newestDeals',
    fetchFunction: () => getNewestDeals(4),
    seeAllLink: "/dealsBrowse?sort=newest",
    background: "bg-gradient-to-r from-deal-green to-emerald-600"
  }
];

const FeaturedDeals: React.FC = () => {
  // We'll use React Query to fetch the deals for each section
  const gettingWarmDealsQuery = useQuery(sectionData[0].queryKey, sectionData[0].fetchFunction);
  //const trendingDealsQuery = useQuery(sectionData[1].queryKey, sectionData[1].fetchFunction);
  const newestDealsQuery = useQuery(sectionData[1].queryKey, sectionData[1].fetchFunction);
  
  // Map queries to sections
  const sections = [
    {
      ...sectionData[0],
      data: gettingWarmDealsQuery.data,
      isLoading: gettingWarmDealsQuery.isLoading
    },
    // {
    //   ...sectionData[1],
    //   data: trendingDealsQuery.data,
    //   isLoading: trendingDealsQuery.isLoading
    // },
    {
      ...sectionData[1],
      data: newestDealsQuery.data,
      isLoading: newestDealsQuery.isLoading
    }
  ];

  return (
    <div className="container mx-auto px-4 sm:px-6 space-y-10">
      {sections.map((section, sectionIndex) => (
        <div key={section.title} className="animate-fade-in" style={{ animationDelay: `${sectionIndex * 0.1}s` }}>
          <div className="mb-6 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${section.background}`}>
                {section.icon}
              </div>
              <h2 className="text-xl font-display font-semibold text-gray-800">{section.title}</h2>
            </div>
            
            <Link to={section.seeAllLink} className="flex items-center gap-1 text-deal-blue hover:text-deal-orange transition-colors">
              <span>View all</span>
              <ChevronRight className="w-4 h-4" />
            </Link>
          </div>
          
          {section.isLoading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[...Array(4)].map((_, index) => (
                <div 
                  key={index} 
                  className="animate-pulse glass rounded-xl overflow-hidden h-[300px]"
                >
                  <div className="h-44 bg-gray-200"></div>
                  <div className="p-4 space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : section.data && section.data.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {section.data.map((deal: any, index: number) => (
                <div 
                  key={deal.id} 
                  className="animate-slide-up" 
                  style={{ animationDelay: `${sectionIndex * 0.1 + index * 0.05}s` }}
                >
                  <DealCard deal={deal} showActions={false} />
                </div>
              ))}
            </div>
          ) : (
            <div className="glass text-center py-12 rounded-xl">
              <p className="text-gray-500">No deals available at the moment.</p>
              <button className="mt-4 btn-secondary-new text-sm">Notify Me When Available</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FeaturedDeals; 